import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { throwError, timeout } from 'rxjs';

const REQUEST_TIMEOUT = 30_000;

// Rethrows as the status-0 shape every downstream handler already treats as a network failure,
// so a dead socket can never wedge a concatMap effect queue or the loader overlay.
export const timeoutInterceptor: HttpInterceptorFn = (req, next) => {
    return next(req).pipe(
        timeout({
            each: REQUEST_TIMEOUT,
            with: () => throwError(() => new HttpErrorResponse({ url: req.url, status: 0, statusText: 'Timeout' })),
        }),
    );
};
